module.exports = __webpack_public_path__ + "static/media/FFPO-LOGO-NEW.eaff09b3.png";